<template>
  <v-icon :size="size" :color="color" @click="$emit('click', $event)" :disabled="disabled">
    <slot></slot>
  </v-icon>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    color: { type: String, required: false, default: 'blue' },
    size: { type: [Number, String], required: false, default: 30 },
    disabled: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_atoms/Icon.vue